import React, { FC } from 'react'
import { GoogleReCaptchaProvider as ReCaptchaProvider } from 'react-google-recaptcha-v3'

const GoogleReCaptchaProvider: FC = ({ children }) => (
  <>
    <ReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CAPTCHA} useRecaptchaNet>
      <>{children}</>
    </ReCaptchaProvider>
  </>
)

export default GoogleReCaptchaProvider
